export interface FormatNumberStringOptions {
  /** Prefix for positive values (e.g. "+"). Omit to show no prefix. */
  plus?: string;
  /** Prefix for negative values (e.g. "-"). Omit to use the number's built-in minus. */
  minus?: string;
  /** Unit suffix (e.g. "kcal", "g"). */
  units?: string;
  /** Label when value is zero. Omit to return null for zero. */
  zeroLabel?: string;
}

/**
 * Formats a number as a signed string with optional units.
 *
 * @example
 * formatNumberString(120, { plus: "+", units: "kcal" })  // "+120 kcal"
 * formatNumberString(-85, { minus: "-", units: "kcal" }) // "-85 kcal"
 * formatNumberString(0, { zeroLabel: "Same calories" })   // "Same calories"
 */
export function formatNumberString(
  value: number,
  options: FormatNumberStringOptions = {},
): string | null {
  const { plus = "+", minus = "-", units = "", zeroLabel } = options;

  if (value === 0) {
    return zeroLabel ?? null;
  }

  const sign = value > 0 ? plus : minus;
  const absValue = Math.abs(value);
  const unitPart = units ? ` ${units}` : "";

  return `${sign}${absValue}${unitPart}`;
}
